import colors from './colors';

const semanticTokens = {
  colors,
};

export default semanticTokens;
